import { useParams } from "react-router-dom";
import {
    isTaskRejectProducts,
    isTaskUpdateProductBalances,
} from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { InventoryProductsPage } from "./InventoryProductsPage";

const InventoryProducts = () => {
    const { marketId, taskId } = useParams();

    const { tasks } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[marketId]?.[taskId];

    const isRejectTask = isTaskRejectProducts(currentTask);

    if (
        !currentTask ||
        (!isTaskUpdateProductBalances(currentTask) && !isRejectTask)
    )
        return <NotFound />;

    return (
        <InventoryProductsPage
            marketId={safeMarketId}
            task={currentTask}
            isRejectTask={isRejectTask}
        />
    );
};

export default InventoryProducts;
